// Réponse sans la Frame attendue (session expirée → page de connexion,
// erreur) : la réponse est affichée en page entière au lieu d'une Frame vide,
// sauf si un contrôleur de la Frame l'a déjà prise en charge.
document.addEventListener('turbo:frame-missing', (event) => {
    if (event.defaultPrevented) return;
    event.preventDefault();
    event.detail.visit(event.detail.response);
});
